export function formatLongDate(item) {
    const currentLanguage = localStorage.getItem('eahsLang') ?? 'en';

    // Parse the date
    const incomingDate = new Date(item);

    // Determine if the time is exactly midnight
    const isMidnight = incomingDate.getHours() === 0 && incomingDate.getMinutes() === 0;
    // Define date format options (conditionally show time)
    const dateOptions = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        ...(!isMidnight && {
            hour: "2-digit",
            minute: "2-digit",
            hourCycle: "h12",
        }),
    };

    // Format the date string
    const displayedDate = incomingDate.toLocaleDateString(
        `${currentLanguage}-EG-u-nu-latn`,
        dateOptions
    );

    return displayedDate;
}
